import React from 'react';
import { InputNumber, Form } from 'antd';
import PropTypes from 'prop-types';
import './VDesejado.scss';

const VDesejado = (props) => {
  const {
    rules,
    min,
    max,
    name,
    value,
    edit,
  } = props;

  return (
    <Form.Item
      className="VDesejado"
      label={<span className="field-title-text">V% desejado </span>}
      name={name}
      rules={rules}
      initialValue={value || undefined}
    >
      <InputNumber
        disabled={edit}
        style={{ width: '100%' }}
        {...(min !== null && max !== null ? { min, max } : {})}
      />
    </Form.Item>
  );
};

VDesejado.defaultProps = {};
VDesejado.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  edit: PropTypes.bool,
};

export default VDesejado;
